import type { ConversationPlan } from '@knownow/domain'
import type { IConversationPlanRepository } from '@knownow/domain'

export class ListPlansUseCase {
  constructor(private readonly repo: IConversationPlanRepository) {}

  async execute(): Promise<readonly ConversationPlan[]> {
    return this.repo.listByOrganization()
  }
}
